<div class="lum-picklist-item-filters">
  <div class="flex mb-4">
    <lum-ui-input
      placeholder="Search..."
      class="w-50"
      [debounceTime]="500"
      (inputChangeEvent)="searchEvent.emit($event)"
    ></lum-ui-input>
    <!-- <lum-autocomplete placeholder="Search..." class="grow"></lum-autocomplete> -->
    <!-- <lum-dropdown
      class="ml-4"
      label="Filter By"
      type="tertiary"
      [items]="[
        { value: 1, label: 'SKU' },
        { value: 2, label: 'Product Name' },
        { value: 3, label: 'Order Date' },
        { value: 4, label: 'Order Number' }
      ]"
      [showCheckbox]="true"
    >
      <lum-ui-icon icon="funnel" class="mr-2" color="#95969A"></lum-ui-icon>
    </lum-dropdown> -->
  </div>
</div>
